module.exports = __webpack_public_path__ + "resources/file-upload-a68d497b7e5aa84cbf9e9717ec5841c8.svg";